import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpErrorResponse, HttpResponse } from "@angular/common/http";

import { AuthenticationServices } from "./authentication.services";
import { AppAlertsServices } from "./app-alerts.services";

import { BehaviorSubject, Subject, Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/retry';
import 'rxjs/add/observable/of';

@Injectable()

export class AutoFillServices {

  private autoFillTermsSubject = new BehaviorSubject(null);
  onUpdatedAutoFillTerms = this.autoFillTermsSubject.asObservable();

  constructor(
    private http: HttpClient,
    private activeUser: AuthenticationServices,
    private message: AppAlertsServices
  ){
    this.getAutoFillTerms();
  }

  getAutoFillTerms(): Observable<any> {
    if ( this.activeUser.isAdmin ) {
      try {
        const response = this.http.get(`api/AutoFillTerms`, { observe: 'body' } );
        const autoFillTerms = response.pluck( 'body' );

        autoFillTerms.subscribe(
          ( result: any ) => {
            this.autoFillTermsSubject.next( result );
          },
          ( error: HttpErrorResponse ) => {
            this.message.set( error );
            throw error;
          }
        );

        return autoFillTerms;
      }
      catch( error ) { this.message.set( error ) };
    }
    else {
      let message = new HttpErrorResponse({
        error: { name: 'Get AutoFill Terms'},
        status: 403,
        statusText: 'Forbidden'
      })
      this.message.set( message);
    }
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/services/autofill.services.ts